export default __webpack_public_path__ + "static/orange-3091d91542050e3fc5571f81fe1dbf20.png";